/* eslint-disable prettier/prettier */
const blocksContainer = document.querySelector('.content-page--blocks') as HTMLElement
const blockHeadings = blocksContainer?.querySelectorAll('h2') as NodeListOf<HTMLHeadingElement>
const navigationList = document.querySelector('.content-page--navigation--list') as HTMLUListElement

const cleanString = (string: string):string => {
    return string
        .replace(/[åä]/g, "a")
        .replace(/ö/g, "o")
        .replace(/[^a-zA-Z0-9\s]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase()
}

const setHeadingIds = () => {
    if (blockHeadings.length > 0)
    {
        blockHeadings.forEach(item => {
            const id = cleanString(item.innerText)
            item.id = id
        })
    }
}

const setNavList = () => {
    if (blockHeadings.length > 0 && navigationList)
    {
        blockHeadings.forEach(item => {
            const heading = item.innerText
            const id = cleanString(heading)

            const listItem = document.createElement('li')
            const linkItem = document.createElement('a')
            linkItem.href = '#' + id
            linkItem.innerText = heading

            listItem.appendChild(linkItem)
            navigationList.appendChild(listItem)
        })
    }
    else if (navigationList)
    {
        navigationList.closest('.content-page--navigation--container')?.setAttribute('style', 'display: none;')
    }
}

const initIsInView = () => {
    if (blockHeadings.length > 0)
    {
        blockHeadings.forEach(item => {
            const itemlink = document.querySelector('a[href="#' + cleanString(item.innerText) + '"]')
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    itemlink.classList.add('in-view')
                  } else {
                    itemlink.classList.remove('in-view')
                  }
                });
              }, { threshold: 0.75 }) //TODO:test on content and modify threshold if needed

              observer.observe(item.closest('.block'))
        })
    }
}

export default function initContentPage()
{
    setHeadingIds()
    setNavList()
    initIsInView()
}